import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadService } from 'src/app/services/application/load.service';

@Component({
    selector: 'app-reg-success',
    templateUrl: './reg-success.component.html',
    styleUrls: ['../../_auth-shared-styles.scss'],
    standalone: false,
})
export class RegisterSuccessComponent implements OnInit {
    public AuthFormTitle: string = '';
    public constructor(
        private router: Router,
        private load: LoadService,
    ) {
        this.AuthFormTitle =
            this.load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN
                .AUTH_FORM_TEXT ?? 'Личный кабинет пациента';
    }
    public ngOnInit(): void {}
    public goToLogin() {
        this.router.navigate(['/auth/login']);
    }
}
